import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import {Badge, Table, Card} from 'reactstrap';
import MarkdownRender from "../MarkdownRendererComponent";

import ProblemListBreadcrumb from '../breadcrumbs/ProblemListBreadcrumbs';

//Data
import {serverPath} from '../common';

// Route: /s/course/:courseId/topic/:topicId
class CourseProblemList extends Component {

    getData() {
        axios.get(serverPath + "studentService.php", {
            params: {
                action: 'getTopicData',
                topicId: this.props.match.params.topicId,
                courseId: this.props.match.params.courseId
            }
        }).then((response) =>{
			if(response.data){
				var breadcrumbDataTmp = {
					courseId    :this.props.match.params.courseId,
					courseName  :response.data.courseInfo.name,   
					topicName   :response.data.breadcrumbData.topic,
					userPrefix  :"s",
				};

				this.setState({
					breadcrumbData  : breadcrumbDataTmp,
					topicDescription: response.data.topicDescription.description,
					problemList		: response.data.problemList,
				});
			}
        });
    }

    constructor(props) {
        super(props);

        this.state = {
			problemList: [],
			topicDescription : "",
            breadcrumbData: null
        };
    }

    componentDidMount(){this.getData();}

    componentWillReceiveProps(newProps) {
        this.props = newProps;
        this.getData();
    }

    render() {
        var basePath = this.props.match.url + "/problem/";
        var items = this.state.problemList.map((p) => {
            return (
                <tr>
                    <th scope="row"> {p.index} </th>
                    <td>
                        <Link to={basePath + p.problemId} className="default-link"> {p.problemName} </Link>
                    </td>
                    <td align="center">
                        <Badge pill
                               color={p.score === "100" ? "success" : p.score === "0" ? "danger" : "warning"}> {p.score} %
                        </Badge>
                    </td>
                    <td align="center"> {p.timesSolved}</td>
                </tr>);
        });
        return (

            <div className="col-10 offset-1">
                <ProblemListBreadcrumb data = {this.state.breadcrumbData}/>

                <div className="card-container">
                    <Card>
                        <h3 align="center" className="mt-2"> {this.state.breadcrumbData ? this.state.breadcrumbData.topicName: null} </h3>
						<MarkdownRender className="mt-2 text-center" source={this.state.topicDescription}/>
                        <div className="col-8 offset-2 ml-1">
                            <Table bordered style={{"maxWidth":'150%', 'width':'150%'}}>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Zadatak</th>
                                        <th style={{'text-align': 'center'}}> Poeni </th>
                                        <th style={{'text-align': 'center'}} title="Broj studenata koji su uspešno rešili zadatak"> Rešilo studenata</th>
                                    </tr>
                                </thead>
                                <tbody> {items} </tbody>
                            </Table>
                        </div>
                    </Card>
                </div>
            </div>
        );
    }
}

export default CourseProblemList;
